import { OpenNewTabTargetType } from "@voltmoney/types";
import { sideBarNavigate } from "../partnerWeb_Dashboard/utils";
import { ROUTE } from "../../routes";
import { isFromAndroidWebview } from "../../configs/utils";
import SharedPropsService from "../../SharedPropsService";
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    await sideBarNavigate(standardUtilities, action);
};
export const openMenu = async (action, _datastore, { navigate }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await navigate(ROUTE.PARTNER_MENU, {
        routeId: action.routeId
    });
};
export const promoBannerInvite = async (action, _datastore, { openNewTab, instrumentTrack }) => {
    instrumentTrack("COLLATERAL_REQUEST_INITIATED", {
        "page": "collateral"
    });
    console.warn('**** promoBannerInvite Action Triggered ****', action);
    openNewTab(`https://wa.me/919611749295?text=Kindly%20provide%20me%20with%20personalized%20co-branded%20marketing%20materials%20to%20help%20educate%20my%20clients.`, OpenNewTabTargetType.blank);
};
export const downloadClick = async (action, _datastore, { navigate }) => {
    const imageUrl = action?.payload?.imageUrl;
    const file_name = action?.payload?.file_name;
    const collateralCategory = action?.payload?.collateralCategory;
    await navigate(ROUTE.COLLATERAL_DOWNLOAD_INFO, {
        imageUrl: imageUrl,
        file_name: file_name,
        collateralCategory: collateralCategory
    });
};
export const presentationMaterialDownload = async (action, _datastore, { instrumentTrack, setDatastore }) => {
    if (!isFromAndroidWebview()) {
        await setDatastore(ROUTE.COLLATERAL, "presentationMaterialContainerStack", {
            loading: true
        });
    }
    const fileUrl = action.payload.fileUrl;
    const fileType = action.payload.fileType.toLowerCase();
    const fileName = action.payload.fileName.replace(".pdf", "");
    const presentationMaterialCategory = action.payload.categoryName;
    instrumentTrack("PRESENTATION_MATERIAL_DOWNLOAD_BUTTON_CLICKED", {
        pm_name: presentationMaterialCategory
    });
    if (!isFromAndroidWebview()) {
        await setDatastore(ROUTE.COLLATERAL, "presentationMaterialContainerStack", {
            loading: true
        });
    }
    fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
        if (isFromAndroidWebview()) {
            window.open(fileUrl);
            setDatastore(ROUTE.COLLATERAL, "presentationMaterialContainerStack", {
                loading: true
            });
            setTimeout(() => {
                setDatastore(ROUTE.COLLATERAL, "presentationMaterialContainerStack", {
                    loading: false
                });
            }, 3000);
        }
        else {
            // Create a temporary anchor element to initiate the download
            const url = window.URL.createObjectURL(new Blob([blob]));
            const a = document.createElement('a');
            a.href = url;
            a.download = `${fileName}.${fileType}`;
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(url);
            document.body.removeChild(a);
            setDatastore(ROUTE.COLLATERAL, "presentationMaterialContainerStack", {
                loading: false
            });
        }
    })
        .catch((error) => {
        console.warn('Error download file: ', error);
    });
};
export const onFilterSelect = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.COLLATERAL_LANGUAGE_SELECT, {
        collateralListData: action.payload.value,
        filtersSelected: action.payload.filtersSelected
    });
};
export const onCategorySelect = async (action, _datastore, { navigate }) => {
    await SharedPropsService.setSelectedCollateralCategoryName(action.payload.selectedCollateralCategoryName);
    await SharedPropsService.setSelectedCollateralCategory(action.payload.selectedCategory);
};
